import { type ButtonHTMLAttributes, type ReactNode } from "react";
import { useInterruptCard } from "../InterruptCardContext";

/**
 * Approve button — submits `{ type: "accept", args: null }`. Renders null
 * if `interrupt.config.allow_accept` is false. Disabled while a submit
 * is in flight.
 *
 * Children override the label (defaults to "Approve").
 */
export interface ApproveProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
}

export function Approve({ children, onClick, ...props }: ApproveProps) {
  const { interrupt, submit, submitting } = useInterruptCard();
  if (!interrupt.config.allow_accept) return null;

  return (
    <button
      type="button"
      {...props}
      disabled={props.disabled || submitting}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;
        void submit({ type: "accept", args: null });
      }}
      className={[
        "px-3 py-1.5 text-sm font-medium rounded-md",
        "bg-zinc-900 text-white hover:bg-zinc-800",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        props.className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children ?? "Approve"}
    </button>
  );
}
